import { MessageSquare, Tag, UserMinus, X } from 'lucide-react';

import { AnnotateOptionBuilderParams } from '@/sections/asset/types';
import type { DropdownOption } from '@/types/dropdown.types';

export const getAssetAnnotateOptions = ({
  onCommentClick,
  onTagClick,
  onRemoveTagClick,
  onRemoveProfileClick,
  hasProfileAssets,
}: AnnotateOptionBuilderParams): DropdownOption[] => {
  const options: DropdownOption[] = [
    {
      label: 'Add Note',
      icon: <MessageSquare className="size-4" />,
      onClick: onCommentClick,
    },
    {
      label: 'Add Tag',
      icon: <Tag className="size-4" />,
      onClick: onTagClick,
    },
    {
      label: 'Remove Tag',
      icon: <X className="size-4" />,
      onClick: onRemoveTagClick,
    },
  ];

  if (onRemoveProfileClick !== undefined) {
    options.push({
      label: 'Remove Scan Profile',
      icon: <UserMinus className="size-4" />,
      onClick: onRemoveProfileClick,
      disabled: !hasProfileAssets,
    });
  }

  return options;
};
